import clsx from 'clsx';
import React from 'react';

import getSubscriptionPriceBreakdown from '@utils/getSubscriptionPriceBreakdown';

import { OfferPriceProps } from '../interfaces';

const OfferPrice = ({
  billingFrequencyClassName,
  className,
  currentPriceClassName,
  offer: {
    currentPrice,
    currentPriceDisplayOverride,
    originalPrice,
    originalPriceDisplayOverride,
    billingFrequencyOverride,
  },
  originalPriceClassName,
  upgradeSavings,
}: OfferPriceProps) => {
  const { currentPriceToDisplay, hasDiscount, originalPriceToDisplay } =
    getSubscriptionPriceBreakdown({
      currentPrice,
      currentPriceDisplayOverride,
      originalPrice,
      originalPriceDisplayOverride,
    });

  return (
    <>
      <div className={clsx('flex flex-wrap items-center justify-center', className)}>
        <span
          className={clsx(
            'font-suisse-screen text-disclosure-lg text-grayscale-charcoal sm:text-headline-alt-sm',
            currentPriceClassName,
            { '!font-medium': !currentPriceClassName }
          )}
          data-testid="offer-price-current-price"
        >
          ${currentPriceToDisplay.toFixed(0)}
        </span>
        {hasDiscount && (
          <span
            className={clsx(
              'ml-8 font-suisse-screen text-disclosure-lg italic text-grayscale-gray line-through sm:text-headline-alt-sm',
              originalPriceClassName
            )}
            data-testid="offer-price-original-price"
          >
            ${originalPriceToDisplay.toFixed(0)}
          </span>
        )}
        {billingFrequencyOverride && (
          <span
            className={clsx(
              'ml-8 whitespace-nowrap font-suisse-screen text-disclosure-lg text-grayscale-charcoal',
              billingFrequencyClassName
            )}
            data-testid="offer-price-billing-frequency"
          >
            {billingFrequencyOverride}
          </span>
        )}
      </div>
      {upgradeSavings && (
        <span className="font-screen-suisse mx-auto mb-8 block text-byline-md font-normal text-grayscale-gray sm:mb-16">
          {upgradeSavings}
        </span>
      )}
    </>
  );
};

export default OfferPrice;
